<template>
  <div>
    <vx-card v-if="isMounted && !failed">
      <p class="text-subtitle">
        <strong>Selecciona un periodo preestablecido o define un rango de fechas y presiona el botón "Consultar".</strong>
      </p>
      <br />
      <div class="vx-row">
        <div class="vx-col w-full sm:w-2/4 lg:w-1/4 mb-4">
          <vs-select
            class="w-full mb-5"
            @input="setPeriodSelected"
            label="Periodos"
            v-model.lazy="selectedPeriod"
            name="selectedPeriod"
            placeholder="Seleccione una opción"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item,index) in periodsFilter"
              class="w-full"
            />
          </vs-select>
        </div>

        <div class="vx-col w-full sm:w-2/4 lg:w-1/4 mb-4">
          <label for class="vs-input--label">Fecha de inicio</label>
          <datepicker
            placeholder="Fecha inicio"
            :language="es"
            v-model="startDate"
            format="dd/MM/yyyy"
            :disabledDates="disabledDates"
          />
        </div>
        <div class="vx-col w-full sm:w-2/4 lg:w-1/4 mb-4">
          <label for class="vs-input--label">Fecha de término:</label>
          <datepicker
            placeholder="Fecha final"
            :language="es"
            v-model="endDate"
            format="dd/MM/yyyy"
            :disabledDates="disabledDates"
          />
        </div>
        <div class="vx-col w-full sm:w-2/4 lg:w-1/4 mb-4">
          <div class="flex flex-wrap">
            <vs-button @click="datesChanged" color="dark" class="mt-6 mr-1">Consultar</vs-button>
          </div>
        </div>
      </div>

      <vs-table
        :sst="true"
        @sort="handleSort"
        ref="table"
        stripe
        :max-items="30"
        :data="allMovements"
        noDataText="No hay datos disponibles"
      >
        <div slot="header" class="mb-3 flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="pager" v-if="allMovements.length > 0">
            <div class="flex flex-wrap">
              <vs-select
                @input="pager"
                v-model.lazy="numberSearchPage"
                name="numberSearchPage"
              >
                <vs-select-item
                  :key="index+1"
                  :value="index+1"
                  :text="index+1"
                  v-for="(value, index) in allData.last_page"
                  class="w-full"
                />
              </vs-select>
              <!-- <vs-button
                :disabled="allData.prev_page_url ? null:true"
                type="border"
                radius
                @click="pager(allData.prev_page_url)"
                class="mr-2"
                icon-pack="feather"
                icon="icon-chevron-left"
              ></vs-button>
              <vs-button
                v-if="allData.prev_page_url != null"
                text-color="#212121"
                type="flat"
                radius
                @click="pager(allData.first_page_url)"
                class="rounded-circle mr-2"
              >
                <strong>1 ..</strong>
              </vs-button>
              <vs-button type="flat" text-color="dark" radius class="mr-2">
                <strong>{{ allData.current_page }}</strong>
              </vs-button>
              <vs-button
                v-if="allData.next_page_url != null"
                text-color="#212121"
                type="flat"
                radius
                @click="pager(allData.last_page_url)"
                class="rounded-circle mr-2"
              >
                <strong>.. {{ allData.last_page }}</strong>
              </vs-button>
              <vs-button
                :disabled="allData.next_page_url ? null:true"
                type="border"
                radius
                @click="pager(allData.next_page_url)"
                class="mr-2"
                icon-pack="feather"
                icon="icon-chevron-right"
              ></vs-button> -->
            </div>
          </div>
          <!-- ITEMS PER PAGE -->
          <div
            v-if="totalRecords > 0"
            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2">{{ from }} - {{ to }} de {{ totalRecords }}</span>
          </div>
        </div>
        <template slot="thead">
          <vs-th
            class="bold"
            v-for="(col, idx) in columns"
            v-bind:key="idx"
            :sort-key="col.sortable ? col.key : null"
          >{{col.title}}</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
            <vs-td>{{ dateTimeFormat(tr.created_at) }}</vs-td>
            <vs-td>{{ tr.concept }}</vs-td>
            <vs-td style="color:#ef5350">
              <strong>{{ costFormat(tr.outcome) }}</strong>
            </vs-td>
            <vs-td style="color:#388E3C">
              <strong>{{ costFormat(tr.income) }}</strong>
            </vs-td>
            <vs-td style="color:#757575">
              <strong>{{ costFormat(tr.final_balance) }}</strong>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import formatHelper from "@mixins/formatHelper";
import dateHelper from "@mixins/dateHelper";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";

const columnDefinitions = [
  { title: "FECHA", key: "created_at", sortable: true },
  { title: "CONCEPTO", key: "concept", sortable: true },
  { title: "EGRESO", key: "outcome", sortable: true },
  { title: "INGRESO", key: "income", sortable: true },
  { title: "SALDO", key: "final_balance", sortable: true },
];

export default {
  name: "ApplicantMovements",
  props: ["project_id"],
  mixins: [formatHelper, dateHelper],
  components: {
    Datepicker,
  },
  async mounted() {
    await this.loadMovements(this.startDate, this.endDate);
  },
  data() {
    return {
      es: es,
      allData: [],
      numberSearchPage: 1,
      orderKey: "",
      getAllRecords: false,
      today: new Date(),
      startDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate() - 90
      ),
      endDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ),
      columns: columnDefinitions,
      isMounted: false,
      csvFileName: "movimientos.csv",
      loading: false,
      failed: false,
      disabledDates: {
        from: new Date(),
      },
      selectedPeriod: 0,
      periodsFilter: [
        { text: "Últimos 90 días", value: 0 },
        { text: "Periodo actual", value: 1 },
        { text: "Periodo anterior", value: 2 },
        { text: "Periodo previo al anterior", value: 3 },
      ],
      fieldsToExport: [
        "created_at",
        "concept",
        "outcome",
        "income",
        "final_balance",
      ],
      labelsToExport: {
        created_at: "Fecha",
        concept: "Concepto",
        outcome: "Egreso",
        income: "Ingreso",
        final_balance: "Saldo",
      },
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    exportFileName: function () {
      return this.user === null
        ? this.csvFileName
        : `movimientos(${this.stringStartDate}-${this.stringEndDate}).csv`;
    },
    allMovements() {
      return this.allData.data;
    },
    from() {
      return this.allData.from;
    },
    to() {
      return this.allData.to;
    },
    totalRecords() {
      return this.allData.total;
    },
    stringStartDate() {
      return this.startDate.toISOString().slice(0, 10);
    },
    stringEndDate() {
      return this.endDate.toISOString().slice(0, 10);
    },
  },
  watch: {
    loading: function () {
      if (this.loading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
  },
  methods: {
    async loadMovements(
      start,
      end,
      url = `/api/cobranza/proyectos/${this.project_id}/applicantMovements`
    ) {
      if (start == null && end == null) {
        start = this.startDate;
        end = this.endDate;
      }
      this.isMounted = false;
      this.loading = true;
      this.failed = false;
      try {
        const data = {
          start: start,
          end: end,
        };
        const response = await axios.post(url, data);
        this.allData = response.data;
        this.allMovements.forEach((movement) => {
          const nn = movement.trx_type.substr(1, 1);
          movement.date = new Date(movement.created_at);
          if (nn !== "1") {
            movement.type = "charge";
            movement.outcome = movement.amount;
            movement.income = 0;
          } else {
            movement.type = "deposit";
            movement.income = movement.amount;
            movement.outcome = 0;
          }
        });
      } catch (e) {
        this.failed = true;
      }
      this.isMounted = true;
      this.loading = false;
    },
    async datesChanged() {
      if (this.startDate > this.endDate) {
        this.errorNotifDialog(
          "Aviso",
          "La fecha de inicio no puede ser mayor a la de fin"
        );
      } else {
        this.selectedPeriod = null;
        await this.loadMovements(this.startDate, this.endDate);
      }
    },
    async handleSort(key, active) {
      switch (key) {
        case "created_at":
          this.allMovements.sort(function (a, b) {
            return (
              Number(new Date(a.created_at)) - Number(new Date(b.created_at))
            );
          });
          break;
        case "concept":
          this.allMovements.sort();
          break;
        case "income":
          this.allMovements.sort(function (a, b) {
            return a.income - b.income;
          });
          break;
        case "outcome":
          this.allMovements.sort(function (a, b) {
            return a.outcome - b.outcome;
          });
          break;
        case "final_balance":
          this.allMovements.sort(function (a, b) {
            return a.final_balance - b.final_balance;
          });
          break;
        default:
          break;
      }
    },
    async pager() {
      let url=`/api/cobranza/proyectos/${this.project_id}/applicantMovements?page=${this.numberSearchPage}`;
      await this.loadMovements(this.startDate, this.endDate, url);
    },
    async setPeriodSelected() {
      switch (this.selectedPeriod) {
        case 0:
          this.startDate = new Date(
            this.today.getFullYear(),
            this.today.getMonth(),
            this.today.getDate() - 90
          );
          this.endDate = this.today;
          break;
        case 1:
          this.startDate = new Date(
            this.today.getFullYear(),
            this.today.getMonth(),
            1
          );
          this.endDate = new Date(
            this.today.getFullYear(),
            this.today.getMonth() + 1,
            0
          );
          break;
        case 2:
          this.startDate = new Date(
            this.today.getFullYear(),
            this.today.getMonth() - 1,
            1
          );
          this.endDate = new Date(
            this.startDate.getFullYear(),
            this.startDate.getMonth() + 1,
            0
          );
          break;
        case 3:
          this.startDate = new Date(
            this.today.getFullYear(),
            this.today.getMonth() - 2,
            1
          );
          this.endDate = new Date(
            this.startDate.getFullYear(),
            this.startDate.getMonth() + 1,
            0
          );
          break;
        default:
          break;
      }
      await this.loadMovements(this.startDate, this.endDate);
    },
  },
};
</script>


<style scoped lang="scss">
::v-deep .vdp-datepicker__calendar {
  position: fixed;
}
</style>